import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [{ name: "검진구분" }, { name: "구분(설립별)" }, { name: getFieldLabel() }, { name: "이름" }, { name: "구분" }, { name: "세부구분" }, { name: "직종" }, { name: "정밀검진 결과" }, { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return transformType(func.getContent(value).inputB_2_value); // 검진구분
      case 1:
        return func.getContent(value).inputA_2; // 구분(설립별)
      case 2:
        return func.getContent(value).inputA_3; // 학교(기관)명
      case 3:
        return func.getContent(value).inputA_8; // 이름
      case 4:
        return func.getContent(value).inputA_5; // 구분
      case 5:
        return func.getContent(value).inputA_6; // 세부구분
      case 6:
        return func.getContent(value).inputA_7; // 직종
      case 7:
        return func.getContent(value).inputC_2; // 정밀검진 결과
      case 8:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 9:
        return func.getCreatedDate(value.created_at); // 세부구분
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.disasterType) returnData.push("content$body.inputD_3*[:default_disaster]");

    switch (nav.value.searchType) {
    case "구분(설립별)":
      returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
      break;
    case getFieldLabel():
      returnData.push("content$body.inputD_1*%[:default_skw]%");
      break;
    case "이름":
      returnData.push("content$body.stdInfo.department*%[:default_skw]%");
      break;
    case "구분":
      returnData.push("content$body.stdInfo.com_name*%[:default_skw]%");
      break;
    case "세부구분":
      returnData.push("content$body.stdInfo.com_name*%[:default_skw]%");
      break;
    case "직종":
      returnData.push("content$body.stdInfo.com_name*%[:default_skw]%");
      break;
    case "정밀검진 결과":
      returnData.push("content$body.stdInfo.com_name*%[:default_skw]%");
      break;
    case "작성자":
      returnData.push("content$body.stdInfo.writer_name*%[:default_skw]%");
      break;
    }

    return returnData;
  },
};

const transformType = function (type) {
  if (type === "4A") {
    return "폐암의심";
  } else if (type === "4B" || type === "4X") {
    return "폐암 매우 의심";
  } else {
    return type;
  }
};
